import { fabric } from 'fabric';
export const getTopBottomRightleft = (group, item) => {
  const matrix = group.calcTransformMatrix();
  const xTl = fabric.util.transformPoint(item.calcACoords().tl, matrix).x;
  const xTr = fabric.util.transformPoint(item.calcACoords().tr, matrix).x;
  const xBl = fabric.util.transformPoint(item.calcACoords().bl, matrix).x;
  const xBr = fabric.util.transformPoint(item.calcACoords().br, matrix).x;
  return { xTl, xTr, xBl, xBr };
};
export const getTopBottomRightleftY = (group, item) => {
  const matrix = group.calcTransformMatrix();
  const yTl = fabric.util.transformPoint(item.calcACoords().tl, matrix).y;
  const yTr = fabric.util.transformPoint(item.calcACoords().tr, matrix).y;
  const yBl = fabric.util.transformPoint(item.calcACoords().bl, matrix).y;
  const yBr = fabric.util.transformPoint(item.calcACoords().br, matrix).y;
  return { yTl, yTr, yBl, yBr };
};
export const getCurrentSpacing = (preObject, nextObject, group) => {
  const maxPre = getTopBottomRightleft(group, preObject);
  const maxPreX = Math.max(...Object.values(maxPre));
  const minNext = getTopBottomRightleft(group, nextObject);
  const minNextX = Math.min(...Object.values(minNext));
  return minNextX - maxPreX;
};
export const getCurrentSpacingHeight = (preObject, nextObject, group) => {
  const maxPre = getTopBottomRightleftY(group, preObject);
  const maxPreX = Math.max(...Object.values(maxPre));
  const minNext = getTopBottomRightleftY(group, nextObject);
  const minNextX = Math.min(...Object.values(minNext));
  return minNextX - maxPreX;
};

export const getMinCoordx = objectCoord => {
  return Math.min(...objectCoord);
};
export const getLeftRightOfGroup = group => {
  const topLeft = group.aCoords.tl.x;
  const topRight = group.aCoords.tr.x;
  let firstObjectId;
  let lastObjectId;

  group.forEachObject(function(item) {
    const minObjectCoordx = Math.min(
      ...Object.values(getTopBottomRightleft(group, item))
    );
    const maxObjectCoordx = Math.max(
      ...Object.values(getTopBottomRightleft(group, item))
    );

    if (minObjectCoordx.toFixed(5) === topLeft.toFixed(5)) {
      firstObjectId = item.id;
    }
    if (maxObjectCoordx.toFixed(5) === topRight.toFixed(5)) {
      lastObjectId = item.id;
    }
  });

  return { firstObjectId, lastObjectId };
};
export const sortByLeft = objectGroup => {
  objectGroup._objects.sort(function(a, b) {
    return (
      Math.min(...Object.values(getTopBottomRightleft(objectGroup, a))) -
      Math.min(...Object.values(getTopBottomRightleft(objectGroup, b)))
    );
  });

  return objectGroup._objects;
};

export const sortByTop = objectGroup => {
  objectGroup._objects.sort(function(a, b) {
    return (
      Math.min(...Object.values(getTopBottomRightleftY(objectGroup, a))) -
      Math.min(...Object.values(getTopBottomRightleftY(objectGroup, b)))
    );
  });
  return objectGroup._objects;
};
export const groupItemsRefresh = group => {
  group.forEachObject(function(item) {
    group.removeWithUpdate(item).addWithUpdate(item);
  });
  group.setCoords();
  group.canvas.renderAll();
};

export const calWidth = (o, activeObjects) => {
  const { xTl, xTr, xBl, xBr } = getTopBottomRightleft(activeObjects, o);
  let width = 0;
  let convertAngle = o.angle < 0 ? o.angle + 360 : o.angle;
  if (convertAngle == 0) {
    width = xTr - xTl;
  }

  if (convertAngle > 0 && convertAngle < 90) {
    width = xTr - xBl;
  }
  if (convertAngle == 90) width = xTl - xBl;
  if (convertAngle > 90 && convertAngle < 180) {
    width = xTl - xBr;
  }
  if (convertAngle == 180) width = xBl - xBr;

  if (convertAngle > 180 && convertAngle < 270) {
    width = xBl - xTr;
  }
  if (convertAngle == 270) width = xBr - xTr;
  if (convertAngle > 270) {
    width = xBr - xTl;
  }
  return width;
};
export const calHeight = (o, activeObjects) => {
  const { yTl, yTr, yBl, yBr } = getTopBottomRightleftY(activeObjects, o);
  let height = 0;
  let convertAngle = o.angle < 0 ? o.angle + 360 : o.angle;
  if (convertAngle == 0) {
    height = yBl - yTl;
  }

  if (convertAngle > 0 && convertAngle < 90) {
    height = yBr - yTl;
  }
  if (convertAngle == 90) height = yBr - yTl;
  if (convertAngle > 90 && convertAngle < 180) {
    height = yTr - yBl;
  }
  if (convertAngle == 180) height = yTr - yBl;

  if (convertAngle > 180 && convertAngle < 270) {
    height = yTl - yBr;
  }
  if (convertAngle == 270) height = yTl - yTr;
  if (convertAngle > 270) {
    height = yBl - yTr;
  }
  return height;
};
export const distributesX = activeObject => {
  const arraySorted = sortByLeft(activeObject);
  let i;
  let totalBoxesWidth = 0;

  activeObject.forEachObject(function(item) {
    totalBoxesWidth += calWidth(item, activeObject);
  });
  const kc = (activeObject.width - totalBoxesWidth) / (activeObject.size() - 1);

  for (i = 1; i < arraySorted.length - 1; i++) {
    arraySorted[i].set({
      left:
        arraySorted[i].left +
        kc -
        getCurrentSpacing(arraySorted[i - 1], arraySorted[i], activeObject)
    });
  }
};

export const distributesY = activeObject => {
  const arraySorted = sortByTop(activeObject);
  let i, top;
  let totalBoxesHeight = 0;

  activeObject.forEachObject(function(item) {
    totalBoxesHeight += calHeight(item, activeObject);
  });
  const kc =
    (activeObject.height - totalBoxesHeight) / (activeObject.size() - 1);

  for (i = 1; i < arraySorted.length - 1; i++) {
    top =
      arraySorted[i].top +
      kc -
      getCurrentSpacingHeight(arraySorted[i - 1], arraySorted[i], activeObject);
    arraySorted[i].set({ top: top });
  }
};

const handleGlobalAlignmentLeftCase = (activeObj, groupWidth) => {
  activeObj.forEachObject(o => {
    let left = 0;
    if (o.angle >= 0 && o.angle <= 90) {
      left = o.aCoords.tl.x - o.aCoords.bl.x;
    }
    if ((o.angle > 90 && o.angle <= 180) || o.angle == -180) {
      left = o.aCoords.tl.x - o.aCoords.br.x;
    }
    if (
      (o.angle > 180 && o.angle <= 270) ||
      (o.angle <= -90 && o.angle > -180)
    ) {
      left = o.aCoords.tl.x - o.aCoords.tr.x;
    }
    if (o.angle > 270 || (o.angle < 0 && o.angle > -90)) {
      left = 0;
    }
    o.set({ left: left - groupWidth / 2 });
  });
};

const handleGlobalAlignmentRightCase = (activeObj, groupWidth) => {
  activeObj.forEachObject(o => {
    let left = 0;
    if (o.angle <= 90) {
      left = o.aCoords.tl.x + (groupWidth - o.aCoords.tr.x);
    }
    if ((o.angle > 90 && o.angle <= 180) || o.angle == -180) {
      left = groupWidth;
    }
    if (
      (o.angle > 180 && o.angle <= 270) ||
      (o.angle <= -90 && o.angle > -180)
    ) {
      left = o.aCoords.tl.x + (groupWidth - o.aCoords.bl.x);
    }
    if (o.angle > 270 || (o.angle < 0 && o.angle > -90)) {
      left = o.aCoords.tl.x + (groupWidth - o.aCoords.br.x);
    }
    o.set({ left: left - groupWidth / 2 });
  });
};

const handleGlobalAlignmentTopCase = (activeObj, groupHeight) => {
  activeObj.forEachObject(o => {
    let top = 0;
    if ((o.angle > 90 && o.angle <= 180) || o.angle == -180) {
      top = o.aCoords.tl.y - o.aCoords.bl.y;
    }
    if (
      (o.angle > 180 && o.angle <= 270) ||
      (o.angle <= -90 && o.angle > -180)
    ) {
      top = o.aCoords.tl.y - o.aCoords.br.y;
    }
    if (o.angle > 270 || (o.angle < 0 && o.angle > -90)) {
      top = o.aCoords.tl.y - o.aCoords.tr.y;
    }
    o.set({ top: top - groupHeight / 2 });
  });
};

const handleGlobalAlignmentBottomCase = (activeObj, groupHeight) => {
  activeObj.forEachObject(o => {
    let top = 0;
    if (o.angle <= 90) {
      top = o.aCoords.tl.y + (groupHeight - o.aCoords.br.y);
    }
    if ((o.angle > 90 && o.angle <= 180) || o.angle == -180) {
      top = o.aCoords.tl.y + (groupHeight - o.aCoords.tr.y);
    }
    if (
      (o.angle > 180 && o.angle <= 270) ||
      (o.angle <= -90 && o.angle > -180)
    ) {
      top = groupHeight;
    }
    if (o.angle > 270 || (o.angle < 0 && o.angle > -90)) {
      top = o.aCoords.tl.y + (groupHeight - o.aCoords.bl.y);
    }
    o.set({ top: top - groupHeight / 2 });
  });
};

const getTopValieForGlobalAlignmentCenterHCase = o => {
  let top = 0;
  if (o.angle == 0) {
    top = -(o.aCoords.bl.y - o.aCoords.tl.y) / 2;
  }
  if (o.angle == 90) {
    top = -(o.aCoords.tr.y - o.aCoords.tl.y) / 2;
  }
  if (o.angle == 180 || o.angle == -180) {
    top = (o.aCoords.tl.y - o.aCoords.bl.y) / 2;
  }
  if (o.angle == 270 || o.angle == -90) {
    top = (o.aCoords.tl.y - o.aCoords.tr.y) / 2;
  }
  return top;
};

const handleGlobalAlignmentCenterHCase = activeObj => {
  activeObj.forEachObject(o => {
    let top = getTopValieForGlobalAlignmentCenterHCase(o);
    if (
      (o.angle > 0 && o.angle < 90) ||
      (o.angle > 180 && o.angle < 270) ||
      (o.angle < -90 && o.angle > -180)
    ) {
      top =
        o.aCoords.tl.y -
        (o.aCoords.bl.y + (o.aCoords.tr.y - o.aCoords.bl.y) / 2);
    }
    if (
      (o.angle > 90 && o.angle < 180) ||
      o.angle > 270 ||
      (o.angle < 0 && o.angle > -90)
    ) {
      top = (o.aCoords.tl.y - o.aCoords.br.y) / 2;
    }
    o.set({ top: top });
  });
};

const getTopValieForGlobalAlignmentCenterVCase = o => {
  let left = 0;
  if (o.angle == 0) {
    left = -(o.aCoords.tr.x - o.aCoords.tl.x) / 2;
  }
  if (o.angle == 90) {
    left = (o.aCoords.tl.x - o.aCoords.bl.x) / 2;
  }
  if (o.angle == 180 || o.angle == -180) {
    left = (o.aCoords.tl.x - o.aCoords.tr.x) / 2;
  }
  if (o.angle == 270 || o.angle == -90) {
    left = -(o.aCoords.bl.x - o.aCoords.tl.x) / 2;
  }
  return left;
};

const handleGlobalAlignmentCenterVCase = activeObj => {
  activeObj.forEachObject(o => {
    let left = getTopValieForGlobalAlignmentCenterVCase(o);
    if (
      (o.angle > 0 && o.angle < 90) ||
      (o.angle > 180 && o.angle < 270) ||
      (o.angle < -90 && o.angle > -180)
    ) {
      left =
        o.aCoords.tl.x -
        (o.aCoords.bl.x + (o.aCoords.tr.x - o.aCoords.bl.x) / 2);
    }
    if (
      (o.angle > 90 && o.angle < 180) ||
      o.angle > 270 ||
      (o.angle < 0 && o.angle > -90)
    ) {
      left = (o.aCoords.tl.x - o.aCoords.br.x) / 2;
    }
    o.set({ left: left });
  });
};

export const applyGlobalAlignment = (alignType, activeObj) => {
  const groupWidth = activeObj.width;
  const groupHeight = activeObj.height;

  switch (alignType) {
    case 'left':
      handleGlobalAlignmentLeftCase(activeObj, groupWidth);
      groupItemsRefresh(activeObj);
      break;
    case 'right':
      handleGlobalAlignmentRightCase(activeObj, groupWidth);
      groupItemsRefresh(activeObj);
      break;
    case 'top':
      handleGlobalAlignmentTopCase(activeObj, groupHeight);
      groupItemsRefresh(activeObj);
      break;
    case 'bottom':
      handleGlobalAlignmentBottomCase(activeObj, groupHeight);
      groupItemsRefresh(activeObj);
      break;
    case 'centerH':
      handleGlobalAlignmentCenterHCase(activeObj);
      groupItemsRefresh(activeObj);
      break;
    case 'centerV':
      handleGlobalAlignmentCenterVCase(activeObj);
      groupItemsRefresh(activeObj);
      break;
    case 'distributeV':
      distributesX(activeObj);
      break;
    case 'distributeH':
      distributesY(activeObj);
      break;
  }
};
